import { regionData } from 'element-china-area-data';

export function companySelection(config, companyId) {
  return (config.companies || []).find(company => String(company.companyId) === String(companyId));
}

export function scopedBrands(config, companyId, brands) {
  if (!companyId) return [];
  if (config.allCompanies) return brands;
  const company = companySelection(config, companyId);
  if (!company) return [];
  return company.allBrands ? brands : brands.filter(brand => (company.brands || []).some(id => String(id) === String(brand.id)));
}

export function scopedRegions(config, companyId, brandId, tree = regionData) {
  if (!companyId || !brandId) return [];
  if (config.allCompanies) return tree;
  const company = companySelection(config, companyId);
  if (!company || (!company.allBrands && !(company.brands || []).some(id => String(id) === String(brandId)))) return [];
  const scope = (company.brandRegions || []).find(row => String(row.brandId) === String(brandId));
  if (!scope || scope.allRegions) return tree;
  const paths = (scope.regions || []).map(path => path.codes.map(String));
  function prune(nodes, prefix) {
    return nodes.reduce((result, node) => {
      const path = prefix.concat(String(node.value));
      const matches = paths.filter(allowed => path.every((code, i) => i >= allowed.length || code === allowed[i]));
      if (!matches.length) return result;
      if (matches.some(allowed => allowed.length <= path.length)) result.push(node);
      else if (node.children) {
        const children = prune(node.children, path);
        if (children.length) result.push({ ...node, children });
      }
      return result;
    }, []);
  }
  return prune(tree, []);
}

export function validRegionPath(tree, path) {
  if (!Array.isArray(path) || path.length !== 3) return false;
  let nodes = tree;
  return path.every(code => {
    const node = (nodes || []).find(item => String(item.value) === String(code));
    nodes = node && node.children;
    return !!node;
  });
}

export default {
  data() {
    return { entryScope: { allCompanies: false, companies: [] }, entryScopeLoading: false };
  },
  computed: {
    entryBrands() {
      return scopedBrands(this.entryScope, this.orderManageArray.companyId, this.deviceBrandDrownList);
    },
    entryRegions() {
      return scopedRegions(this.entryScope, this.orderManageArray.companyId, this.orderManageArray.deviceBrandId);
    },
  },
  watch: {
    dialogFormAdd(open) {
      if (open) this.loadEntryScope();
    },
    'orderManageArray.companyId'(value, previous) {
      if (!this.dialogFormAdd || String(value || '') === String(previous || '')) return;
      this.clearInvalidEntrySelection();
    },
    'orderManageArray.deviceBrandId'(value, previous) {
      if (this.dialogFormAdd && String(value || '') !== String(previous || '')) this.clearInvalidEntrySelection();
    },
  },
  methods: {
    clearInvalidEntrySelection() {
      if (!this.entryBrands.some(brand => String(brand.id) === String(this.orderManageArray.deviceBrandId))) {
        this.$set(this.orderManageArray, 'deviceBrandId', '');
        this.$set(this.orderManageArray, 'brandId', '');
        this.$set(this.orderManageArray, 'modelId', '');
        this.deviceModelDrownList = [];
      }
      if (!validRegionPath(this.entryRegions, this.orderManageArray.fullLocalId)) {
        this.$set(this.orderManageArray, 'fullLocalId', []);
      }
    },
    validateEntrySelection() {
      if (this.entryScopeLoading) {
        this.$message.warning('公司范围加载中，请稍后重试');
        return false;
      }
      if (!this.entryBrands.some(brand => String(brand.id) === String(this.orderManageArray.deviceBrandId))
          || !validRegionPath(this.entryRegions, this.orderManageArray.fullLocalId)) {
        this.$message.error('请选择公司范围内的品牌和省市区');
        return false;
      }
      return true;
    },
    async loadEntryScope() {
      this.entryScopeLoading = true;
      this.entryScope = { allCompanies: false, companies: [] };
      try {
        const responses = await Promise.all([
          this.axios.get('/v1/web/user-company-access/current'),
          this.axios.get('/v1/web/company-manager/select-company-drown'),
          this.axios.get('/v1/web/device-brand/select-business-brands'),
        ]);
        if (responses.some(response => response.data.code !== 200)) throw new Error('范围加载失败');
        this.entryScope = responses[0].data.data;
        this.companyDrownList = responses[1].data.data || [];
        this.deviceBrandDrownList = responses[2].data.data.list || [];
        this.clearInvalidEntrySelection();
      } catch (error) {
        this.$message.error('加载公司范围失败，请关闭后重试');
      } finally {
        this.entryScopeLoading = false;
      }
    },
  },
};
